<template>
  <div class="dark:bg-gray-700 w-full h-full">
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'App',
  mounted() {
    window.focus();
  }
});
</script>
